<template lang="pug">
  transition
    .SearchListResults
      .SearchListResults_grid
        .SearchListResults_column(
          v-for="columnIndex in nbOfColumns"
          :style="{width: `calc(100% / ${nbOfColumns})`}"
        )
          SampleListItem(
            v-for="(result, resultIndex) in resultsSamples"
            :key="resultIndex + '-col' + columnIndex"
            :item="result"
            class="SampleListItem-in-drawer SampleListItem-in-search"
            v-if="resultIndex % nbOfColumns == (columnIndex - 1)"
          )
</template>

<script>
import { Component } from 'vue-instantsearch'
import SampleListItem from '@/components/SampleListItem'
import SampleModel from '@/models/SampleModel'
import { mapGetters } from 'vuex'
// import { Store } from 'vue-instantsearch'

export default {
  mixins: [Component],
  components: {
    SampleListItem
  },
  props: {
    stack: {
      type: Boolean,
      default: false
    },
    resultsPerPage: {
      type: Number
    },
    items: {
      type: Array
    }
  },
  created () {
    this.updateResultsPerPage()
  },
  data () {
    return {
      stackedResults: null,
      nbOfColumns: 3
    }
  },
  watch: {
    resultsPerPage () {
      this.updateResultsPerPage()
    },
    searchOptions (options) {
    }
  },
  methods: {
    updateResultsPerPage () {
      if (typeof this.resultsPerPage === 'number' && this.resultsPerPage > 0) {
        this.searchStore.resultsPerPage = this.resultsPerPage
      }
    }
  },
  computed: {
    ...mapGetters(['searchOptions']),
    results () {
      if ((this.searchStore.query.length === 0 && this.searchStore.activeRefinements.length === 0) && this.items) {
        return this.items
      }

      if (this.stack === false) {
        return this.searchStore.results
      }

      if (!this.stackedResults) { this.stackedResults = [] }
      if (this.searchStore.page === 1) { this.stackedResults = [] }
      if (this.stackedResults.length === 0 || this.searchStore.results.length === 0) {
        this.stackedResults.push(...this.searchStore.results)
      } else {
        const lastStacked = this.stackedResults[this.stackedResults.length - 1]
        const lastResult = this.searchStore.results[
          this.searchStore.results.length - 1
        ]
        if (lastStacked.objectID !== lastResult.objectID) {
          this.stackedResults.push(...this.searchStore.results)
        }
      }

      return this.stackedResults
    },
    resultsSamples () {
      let r = this.results
      if (this.searchOptions && this.searchOptions.stratigraphic_age_limits) {
        r = r.filter(r => r.stratigraphic_age_limits && parseInt(r.stratigraphic_age_limits.from) >= this.searchOptions.stratigraphic_age_limits.from && parseInt(r.stratigraphic_age_limits.to) <= this.searchOptions.stratigraphic_age_limits.to)
      }

      return r.map(r => new SampleModel(r))
    },
    show () {
      return this.results && this.results.length > 0
    }
  }
}
</script>

<style lang="stylus" scoped>

.SearchListResults
  position: absolute
  top 0
  left 0
  bottom 0
  width: 65%
  background-color $grey-1 // même que la bordure des SampleListItem
  overflow-y auto

  @media $mq_m_only

    width 100%
    top unset
    max-height 50vh

  @media $mq_s_only

    width 100%
    top unset
    max-height 50vh

  &.v-enter,
  &.v-leave-to
    opacity 0

  &.v-enter-active
    transition: opacity 1.3s $ease 1.2s

  &.v-leave-active
    transition: opacity 0.8s $ease

  &_grid
    display: flex
    flex-wrap: wrap
    align-items top
    justify-content flex-start

</style>
